import { emDash } from '../common/stringUtility'

export type CellAccessorFunc<TRow extends object> =
  (row: TRow) => CellValue

export type CellValue = CellValueItem | CellValueItem[]

export type CellValueItem =
  undefined | boolean | number | string

export const toFuncAccessor =
  <TRow extends object>(keyOrAccessor: string | CellAccessorFunc<TRow>): CellAccessorFunc<TRow> =>
    typeof keyOrAccessor === 'function'
    ? keyOrAccessor
    : (row: TRow) => {
      const cell: [string, unknown] | undefined = Object.entries(row).find(([key]) => key === keyOrAccessor)

      if (cell === undefined) {
        console.error(`Failed to find cell by key '${keyOrAccessor}' on row:`, row)
        return emDash
      }

      const cellValue = cell[1]

      switch (typeof cellValue) {
        case 'undefined':
        case 'boolean':
        case 'number':
        case 'string':
          return cellValue

        case 'object': {
          if (cellValue instanceof Array) {
            // Getting generics down here is too hard
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return cellValue
          }

          if (cellValue) {
            console.error(`Bad object in cell by key '${keyOrAccessor}':`, cellValue, 'on row:', row)
          }

          return emDash
        }

        default: {
          console.error(`Bad type for cell by key '${keyOrAccessor}':`, cellValue, 'on row:', row)
          return emDash
        }
      }
    }